import * as THREE from 'three';

/**
 * TECHNICAL MONOCHROME MATERIALS
 * Crisp edge lines, dark solid fills, and highlight states.
 */

export function createMaterials() {
  // Dark subtle solid base for bodies with low opacity
  const solidDark = new THREE.MeshBasicMaterial({
    color: 0x141414,
    transparent: true,
    opacity: 0.08,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1
  });

  // Solid accent (slightly lighter grey for avionics boards)
  const solidAccent = new THREE.MeshBasicMaterial({
    color: 0x202020,
    transparent: true,
    opacity: 0.12,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1
  });

  // Battery solid (dark carbon/slate)
  const solidBattery = new THREE.MeshBasicMaterial({
    color: 0x101010,
    transparent: true,
    opacity: 0.08,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1
  });

  // Reduced opacity crisp technical edge lines (subtle CAD blueprint drawing)
  const edgeLine = new THREE.LineBasicMaterial({
    color: 0xEDEBE6,
    linewidth: 1,
    transparent: true,
    opacity: 0.18
  });

  // Dimmed edge lines (for non-highlighted exploded parts)
  const edgeDimmed = new THREE.LineBasicMaterial({
    color: 0x333333,
    linewidth: 1,
    transparent: true,
    opacity: 0.08
  });

  // Highlighted edge lines (brightest pure white for active subsystem)
  const edgeHighlight = new THREE.LineBasicMaterial({
    color: 0xFFFFFF,
    linewidth: 2,
    transparent: true,
    opacity: 0.85
  });

  // Propeller semi-transparent disc line
  const propLine = new THREE.LineBasicMaterial({
    color: 0x888888,
    linewidth: 1,
    transparent: true,
    opacity: 0.10
  });

  // Technical leader line (thin dashed or solid hairline)
  const leaderLine = new THREE.LineDashedMaterial({
    color: 0x666666,
    dashSize: 0.2,
    gapSize: 0.15,
    linewidth: 1,
    transparent: true,
    opacity: 0.15
  });

  // Ground grid lines
  const gridLine = new THREE.LineBasicMaterial({
    color: 0x222222,
    transparent: true,
    opacity: 0.12
  });

  // Dimension lines in plan view
  const dimensionLine = new THREE.LineBasicMaterial({
    color: 0x888888,
    transparent: true,
    opacity: 0.35
  });

  return {
    solidDark,
    solidAccent,
    solidBattery,
    edgeLine,
    edgeDimmed,
    edgeHighlight,
    propLine,
    leaderLine,
    gridLine,
    dimensionLine,
    isWireframeOnly: false
  };
}
